import store from '@/store/index.js'
export default function(p) {
  console.log(p)
  if(store.state.security.user.company.permissions[p[0]] & p[1]){
    return true
  }else{
    return false
  }
}